import { AwsCloudSolutionsPage } from './AwsCloudSolutionsPage';

export default AwsCloudSolutionsPage;
